import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { isNullOrUndefined } from '../../../lib/typeGuards';
import ContentMessage from '../ContentMessage/ContentMessage';
import { ReportItem, ReportsListElement } from './partials/ReportsListElement';

type ReportsListProps = {
  reports: ReportItem[];
};

export function ReportsList({
  reports,
}: ReportsListProps) {
  const { t } = useSonTranslation('RepotsList');

  if (isNullOrUndefined(reports) || reports.length === 0) {
    return <ContentMessage text={t('noReports')} />;
  }

  return (
    <>
      <ul className="page-membership-matching-rule-list__reportlist">
        {reports &&
          reports.map(reportItem => (
            <ReportsListElement
              key={reportItem.timestamp}
              reportItem={{ ...reportItem }}
            />
          ))}
      </ul>
    </>
  );
}
